module.exports = __webpack_public_path__ + "static/img/shyy_img_xfz.175a77e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shyy_img_xfz.png
// module id = 5CU6
// module chunks = 0